import type InAppNotification from '../../models/InAppNotification'

type NotificationRouteSource = Pick<InAppNotification, 'notificationID' | 'serviceRequestServiceID'>

export const getNotificationTargetPath = (notification: NotificationRouteSource): string => {
    const targetID = notification.serviceRequestServiceID
    const notificationID = notification.notificationID

    if (typeof targetID === 'number' && targetID > 0) {
        const path = `/service-requests?id=${targetID}`
        return typeof notificationID === 'number' && notificationID > 0
            ? `${path}&notificationID=${notificationID}`
            : path
    }

    return '/service-requests'
}